/* Back-in-stock modal (moved out of snippets/product-form.liquid). */
document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('custom-bis-modal');
  const form = document.getElementById('custom-bis-form');
  const msgDiv = document.getElementById('custom-bis-msg');
  const submitBtn = document.getElementById('custom-bis-submit-btn');

  // 1. Open modal when the custom trigger is clicked
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('.custom-bis-trigger')) {
      e.preventDefault();
      modal.classList.add('is-open');
      form.style.display = 'block'; // Reset form visibility
      msgDiv.style.display = 'none'; // Hide success message
      document.getElementById('custom-bis-email').value = ''; // Clear input
    }
  });

  // 2. Close modal logic
  document.querySelectorAll('[data-bis-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      modal.classList.remove('is-open');
    });
  });

  // 3. Handle Form Submission via Klaviyo API
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = document.getElementById('custom-bis-email').value;
      const variantInput = document.querySelector('input[name="id"]');
      const variantId = variantInput ? variantInput.value : '';

      if (!email || !variantId) return;

      // Klaviyo Credentials
      const companyId = 'SFLfyh';
      const listId = 'VfXtza';
      const apiRevision = '2024-07-15';

      // Visual Loading State (Matches pre-order button style)
      submitBtn.disabled = true;
      submitBtn.querySelector('span').innerText = '...';

      // Payload 1: Add to Back In Stock Queue
      const bisPayload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "channels": ["EMAIL"],
            "profile": { "data": { "type": "profile", "attributes": { "email": email } } }
          },
          "relationships": {
            "variant": { "data": { "type": "catalog-variant", "id": `$shopify:::$default:::${variantId}` } }
          }
        }
      };

      // Payload 2: Subscribe to the specific List ID
      const listPayload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "custom_source": "Custom BIS Form",
            "profile": { "data": { "type": "profile", "attributes": { "email": email } } }
          },
          "relationships": {
            "list": { "data": { "type": "list", "id": listId } }
          }
        }
      };

      const fetchOptions = (payload) => ({
        method: 'POST',
        headers: { 'revision': apiRevision, 'Content-Type': 'application/vnd.api+json' },
        body: JSON.stringify(payload)
      });

      // Execute both requests simultaneously
      Promise.all([
        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, fetchOptions(bisPayload)),
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, fetchOptions(listPayload))
      ])
      .then(responses => {
        // Hide the form and show the success message
        form.style.display = 'none';
        msgDiv.innerHTML = "<p>thanks x</p>";
        msgDiv.style.display = 'block';
      })
      .catch(err => {
        console.error('Klaviyo BIS Error:', err);
        msgDiv.innerHTML = "<p>There was an error. Please try again.</p>";
        msgDiv.style.display = 'block';
      })
      .finally(() => {
        // Reset the button text from '...' back to '→→→'
        submitBtn.disabled = false;
        submitBtn.querySelector('span').innerText = '→→→';
      });
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  // Find all Add to Cart buttons on the page
  const atcButtons = document.querySelectorAll('button[name="add"].btn--add-to-cart');
  
  atcButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      // Only trigger if the button isn't disabled (e.g., Sold Out)
      if (!this.disabled) {
        // Force the loading state classes that trigger our CSS
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        
        // Safety fallback: Reset the button after 3 seconds in case the cart 
        // fails to open or the page doesn't redirect.
        setTimeout(() => {
          this.classList.remove('is-loading');
          this.setAttribute('aria-busy', 'false');
        }, 2000);
      }
    });
  });
});
